import type { AxiosError } from 'axios';

interface ErrorDataType {
  code: string;
  details: string;
  message: string;
}

interface ErrorType {
  message: string;
  config: AxiosError['config'];
  response: {
    status: number;
    message: string;
    data: {
      error: string | ErrorDataType;
      errors?: ErrorDataType[];
    };
  };
}

interface ErrorResultDataType {
  type: string;
  status: number;
  code: string;
  message: string;
}

export const errorHandler = (
  error: string | ErrorType,
): ErrorResultDataType => {
  if (typeof error === 'string') {
    return { type: 'unknown', status: -1, code: '', message: error };
  }

  if (error.message && !error.response) {
    return { type: 'unknown', status: -1, code: '', message: error.message };
  }

  if (error.response && error.response.status) {
    const { status, data, message } = error.response;

    const errorResult = ({ code = '', message = '' }) => {
      return {
        type: 'http',
        status,
        code,
        message,
        config: error.config ?? {},
      };
    };

    if (status >= 500)
      return errorResult({
        code: 'server_error',
        message: '伺服器發生錯誤',
      });

    if (message)
      return errorResult({
        code: 'unknown',
      });

    if (typeof data.error === 'string') {
      return errorResult({
        code: 'normal',
        message: data.error,
      });
    } else {
      if (data.errors) {
        return errorResult({
          code: data.errors[0].code,
          message: data.errors[0].message,
        });
      } else {
        return errorResult({
          code: data.error?.code,
          message: data.error?.message,
        });
      }
    }
  } else {
    return { type: 'unknown', status: -1, code: '', message: '發生未知錯誤' };
  }
};
